<template lang="pug">
.pack-list
  .order-pack__header.order-pack__row(
    v-if="showTableHeader"
    :class="{ 'order-pack__row--detail': !!detailType }"
  )
    .order-pack__cell.order-pack__col-check(v-if="!detailType")
      shCheckbox(:value="allRecordsSelected" @input="setAllRecordsSelected" :icon-color="packCheckIconColor" :icon-size="packCheckIconSize")
    .order-pack__cell.order-pack__col-number Orden
    .order-pack__cell.order-pack__col-status Estado
    .order-pack__cell.order-pack__col-name Nombre
    .order-pack__cell.order-pack__col-location Ciudad
    .order-pack__cell.order-pack__col-date Fecha
    .order-pack__cell.order-pack__col-remit.order-pack__remit-header(v-if="!detailType" @click="cycleRemitSelection") Remite
    .order-pack__cell.order-pack__col-message(v-if="!detailType") Mensajes

  shLoader(v-if="showBody && !detailRowOnly" :show="loading")

  .order-pack__list.order-pack__list--detail(v-if="showDetailRow && detailOrderItem")
    PackListOrderRow(
      :item="detailOrderItem"
      is-detail
      :name="shortName(detailOrderItem.name)"
      :location="cutValue(detailOrderItem.location)"
      :date-label="recordDateLabel(detailOrderItem)"
      :status-label="statusLabel(detailOrderItem.status)"
      :status-style="orderTagStyle(detailOrderItem.status)"
      :icon-color="packCheckIconColor"
      :icon-size="packCheckIconSize"
      :show-print="detailHasRemit"
      :print-icon-style="detailPrintIconStyle"
      @print="printDetailRecord"
    )
      template(slot="message")
        .order-actions-container(v-if="detailData" @click.stop="")
          .order-actions.relative
            .undo(v-if="detailAction && detailAction.previousAction")
              img(
                :src="require('@/assets/undo.svg')"
                :alt="`undo-${detailData.status}`"
                :class="{ disabled: detailActionLoading }"
                @click="undoDetailAction"
              )
            .undo(v-else)
            .buttons-actions
              shActionButton(
                v-if="detailAction && detailAction.nextAction"
                :action="detailAction.nextAction"
                :params="detailActionParams"
                :text="detailSendActionText"
                :textRunning="detailSendActionTextRunning"
                :textConfirmation="detailSendConfirmation"
                width="9rem"
              )
              SendSkipGuideToggle(v-if="canSkipGuide" v-model="skipGuide")
              shActionButton(
                :action="generateDetailRemit"
                icon="article"
                text="Generar remite"
                textRunning="Generando remite"
                :normalColor="true"
              )
            span.order-pack__message-text.is-error(v-if="detailPackBlockMessage") {{ detailPackBlockMessage }}

  .order-pack__list.order-pack__list--detail(v-if="showDetailRow && detailChangeItem")
    PackListChangeRow(
      :item="detailChangeItem"
      is-detail
      link-ids
      :name="shortName(detailChangeItem.name)"
      :location="cutValue(detailChangeItem.location)"
      :date-label="recordDateLabel(detailChangeItem)"
      :status-label="statusLabel(detailChangeItem.status)"
      :status-style="orderTagStyle(detailChangeItem.status)"
      :icon-color="packCheckIconColor"
      :icon-size="packCheckIconSize"
      :show-print="detailHasRemit"
      :print-icon-style="detailPrintIconStyle"
      @print="printDetailRecord"
      @open-change="openPackChange"
    )
      template(slot="message")
        .order-actions-container(v-if="detailData" @click.stop="")
          .order-actions.relative
            .undo(v-if="detailAction && detailAction.previousAction")
              img(
                :src="require('@/assets/undo.svg')"
                :alt="`undo-${detailData.status}`"
                :class="{ disabled: detailActionLoading }"
                @click="undoDetailAction"
              )
            .undo(v-else)
            .buttons-actions
              shActionButton(
                v-if="detailAction && detailAction.nextAction"
                :action="detailAction.nextAction"
                :params="detailActionParams"
                :text="detailSendActionText"
                :textRunning="detailSendActionTextRunning"
                :textConfirmation="detailSendConfirmation"
                width="9rem"
              )
              SendSkipGuideToggle(v-if="canSkipGuide" v-model="skipGuide")
              shActionButton(
                :action="generateDetailRemit"
                icon="article"
                text="Generar remite"
                textRunning="Generando remite"
                :normalColor="true"
              )

  .order-pack__list(v-if="showBody && !detailRowOnly && !loading && visibleOrders.length && !detailType")
    PackListOrderRow(
      v-for="orderItem in visibleOrders"
      :key="orderItem.order"
      :item="orderItem"
      show-check
      :selected="isOrderSelected(orderItem.order)"
      link-order
      :name="shortName(orderItem.name)"
      :location="cutValue(orderItem.location)"
      :date-label="recordDateLabel(orderItem)"
      :status-label="statusLabel(orderItem.status)"
      :status-style="orderTagStyle(orderItem.status)"
      :icon-color="packCheckIconColor"
      :icon-size="packCheckIconSize"
      @select="setOrderSelected(orderItem.order, $event)"
      @open-order="openPackOrder"
    )
      template(slot="message")
        span.order-pack__message-text.is-error(v-if="getOrderPackBlockMessage(orderItem)") {{ getOrderPackBlockMessage(orderItem) }}
        span.order-pack__message-text(v-else-if="orderItem.packMessage" :class="packMessageClass(orderItem)") {{ orderItem.packMessage }}

  .order-pack__section-title(v-if="showBody && !detailRowOnly && !loading && visibleChanges.length && !detailType") Cambios

  .order-pack__list(v-if="showBody && !detailRowOnly && !loading && visibleChanges.length && !detailType")
    PackListChangeRow(
      v-for="changeItem in visibleChanges"
      :key="changeItem.change"
      :item="changeItem"
      show-check
      :selected="isChangeSelected(changeItem.change)"
      link-ids
      :name="shortName(changeItem.name)"
      :location="cutValue(changeItem.location)"
      :date-label="recordDateLabel(changeItem)"
      :status-label="statusLabel(changeItem.status)"
      :status-style="orderTagStyle(changeItem.status)"
      :icon-color="packCheckIconColor"
      :icon-size="packCheckIconSize"
      @select="setChangeSelected(changeItem.change, $event)"
      @open-change="openPackChange"
    )
      template(slot="message")
        span.order-pack__message-text(v-if="changeItem.packMessage" :class="packMessageClass(changeItem)") {{ changeItem.packMessage }}
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import mFilters from '@/mixins/filters'
import router from '@my/router'
import PackListOrderRow from './PackListOrderRow.vue'
import PackListChangeRow from './PackListChangeRow.vue'
import shLoader from '@/components/layout/Loader'
import shCheckbox from '@/components/elements/Checkbox'
import shActionButton from '@/components/elements/ActionButton'
import SendSkipGuideToggle from '@/components/elements/order/SendSkipGuideToggle.vue'
import gql from '@my/graphql'
import gqlOrder from '@/graphql/order'
import gqlChange from '@/graphql/change'
import modals from '@my/store/modals'
import { recordHasRemit, latestRemitDiffersFromRecord } from '@/helpers/remit'
import { matchesPackRecordFilters, formatChangeCode } from '@/helpers/packSearch'
import { mapPackOrder, mapPackChange } from '@/store/modules/pack'
import { isBlockedByFraud } from '@/helpers/fraudReview'
import { isBlockedByProductChange, isBlockedByAddressNovelty, orderPackBlockMessage as orderPackBlockMessageHelper, orderSendBlockMessage } from '@/helpers/orderNovelty'

export default {
  name: 'PackList',

  mixins: [mFilters],

  components: {
    PackListOrderRow,
    PackListChangeRow,
    shLoader,
    shCheckbox,
    shActionButton,
    SendSkipGuideToggle
  },

  props: {
    headersOnly: {
      type: Boolean,
      default: false
    },
    bodyOnly: {
      type: Boolean,
      default: false
    },
    detailRowOnly: {
      type: Boolean,
      default: false
    },
    detailType: {
      type: String,
      default: null,
      validator: value => !value || value === 'order' || value === 'change'
    },
    detailData: {
      type: Object,
      default: null
    },
    packFilters: {
      type: Object,
      default: () => ({
        bassica: false,
        sahet: false,
        bogota: false,
        nacional: false
      })
    }
  },

  data () {
    return {
      statusSpanish: {
        paid: 'Pagado',
        packed: 'Empacado',
        sent: 'Enviado'
      },
      packCheckIconColor: 'var(--color-placeholder)',
      packCheckIconSize: '1.75rem',
      orderRemitSelectWithNext: false,
      changeRemitSelectWithNext: false,
      detailActionLoading: false,
      skipGuide: false
    }
  },

  watch: {
    'detailData.order' () {
      this.skipGuide = false
    },
    'detailData.change' () {
      this.skipGuide = false
    }
  },

  computed: {
    ...mapState('pack', [
      'orders',
      'changes',
      'selectedOrders',
      'selectedChanges',
      'loading'
    ]),

    visibleOrders () {
      const filters = {
        bassica: this.packFilters.bassica,
        sahet: this.packFilters.sahet,
        bogota: this.packFilters.bogota,
        nacional: this.packFilters.nacional
      }

      return this.orders
        .filter(order => matchesPackRecordFilters(order, filters))
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    },

    visibleChanges () {
      const filters = {
        bassica: this.packFilters.bassica,
        sahet: this.packFilters.sahet,
        bogota: this.packFilters.bogota,
        nacional: this.packFilters.nacional
      }

      return this.changes
        .filter(change => matchesPackRecordFilters(change, filters))
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    },

    allRecordsSelected () {
      const hasOrders = this.visibleOrders.length > 0
      const hasChanges = this.visibleChanges.length > 0

      if (!hasOrders && !hasChanges) return false

      const ordersOk = !hasOrders || this.visibleOrders.every(order => this.selectedOrders[order.order])
      const changesOk = !hasChanges || this.visibleChanges.every(change => this.selectedChanges[change.change])

      return ordersOk && changesOk
    },

    allOrdersSelected () {
      if (!this.visibleOrders.length) return false
      return this.visibleOrders.every(order => this.selectedOrders[order.order])
    },

    allChangesSelected () {
      if (!this.visibleChanges.length) return false
      return this.visibleChanges.every(change => this.selectedChanges[change.change])
    },

    ordersWithRemit () {
      return this.visibleOrders.filter(recordHasRemit)
    },

    ordersWithoutRemit () {
      return this.visibleOrders.filter(orderItem => !recordHasRemit(orderItem))
    },

    changesWithRemit () {
      return this.visibleChanges.filter(recordHasRemit)
    },

    changesWithoutRemit () {
      return this.visibleChanges.filter(changeItem => !recordHasRemit(changeItem))
    },

    showHeaders () {
      return !this.bodyOnly && !this.detailRowOnly
    },

    showBody () {
      return !this.headersOnly || this.detailRowOnly
    },

    showDetailRow () {
      return !!(this.detailType && this.detailData && (this.bodyOnly || this.detailRowOnly))
    },

    showTableHeader () {
      if (!this.showHeaders) return false
      if (this.detailType === 'order' || this.detailType === 'change') return true
      if (this.detailType) return false
      return !this.loading && (this.visibleOrders.length > 0 || this.visibleChanges.length > 0)
    },

    detailOrderItem () {
      if (!this.detailData || this.detailType !== 'order') return null
      return this.mapDetailOrder(this.detailData)
    },

    detailChangeItem () {
      if (!this.detailData || this.detailType !== 'change') return null
      return this.mapDetailChange(this.detailData)
    },

    detailHasRemit () {
      return this.detailData && recordHasRemit(this.detailData)
    },

    detailPrintIconStyle () {
      const isOutdated = this.detailData && latestRemitDiffersFromRecord(this.detailData)

      return {
        color: isOutdated ? 'var(--color-red)' : this.packCheckIconColor,
        opacity: isOutdated ? 1 : 0.75,
        fontSize: `calc(${this.packCheckIconSize} + 2px)`
      }
    },

    detailAction () {
      if (!this.detailData || !this.detailType) return null

      const actions = this.detailType === 'order'
        ? {
          paid: {
            nextAction: this.packOrder,
            text: 'Empacar',
            textRunning: 'Empacando'
          },
          packed: {
            previousAction: this.unpackOrder,
            nextAction: this.sendOrder,
            text: 'Enviar',
            textRunning: 'Enviando',
            textConfirmation: '¿Deseas enviar la orden?'
          },
          sent: {
            previousAction: this.backSendOrder,
            nextAction: null,
            text: '',
            textRunning: ''
          }
        }
        : {
          paid: {
            previousAction: null,
            nextAction: this.packChange,
            text: 'Empacar',
            textRunning: 'Empacando'
          },
          packed: {
            previousAction: this.unpackChange,
            nextAction: this.sendChange,
            text: 'Enviar',
            textRunning: 'Enviando',
            textConfirmation: '¿Deseas enviar el cambio?'
          },
          sent: {
            previousAction: this.backSendChange,
            nextAction: null,
            text: '',
            textRunning: ''
          }
        }

      const action = actions[this.detailData.status] || null
      if (!action || this.detailType !== 'order') return action
      const isBlocked = this.detailData.status === 'packed'
        ? (isBlockedByFraud(this.detailData) || isBlockedByAddressNovelty(this.detailData))
        : (isBlockedByFraud(this.detailData) || isBlockedByProductChange(this.detailData))
      if (isBlocked) {
        return {
          ...action,
          nextAction: null
        }
      }
      return action
    },

    detailPackBlockMessage () {
      if (this.detailType !== 'order' || !this.detailData) return ''
      if (this.detailData.status === 'packed') return orderSendBlockMessage(this.detailData)
      return orderPackBlockMessageHelper(this.detailData)
    },

    detailActionParams () {
      if (!this.detailData || !this.detailType) return []

      return this.detailType === 'order'
        ? [this.detailData.order]
        : [this.detailData.change]
    },

    canSkipGuide () {
      return !!(this.detailData && this.detailData.status === 'packed' && this.detailAction && this.detailAction.nextAction)
    },

    detailSendActionText () {
      if (this.canSkipGuide && this.skipGuide) return 'E. Sin Guía'
      return this.detailAction && this.detailAction.text
    },

    detailSendActionTextRunning () {
      if (this.canSkipGuide && this.skipGuide) return 'Enviando sin guía'
      return this.detailAction && this.detailAction.textRunning
    },

    detailSendConfirmation () {
      if (!this.detailAction) return ''
      if (!this.detailData || this.detailData.status !== 'packed') return this.detailAction.textConfirmation
      if (!this.skipGuide) return this.detailAction.textConfirmation
      return this.detailType === 'change'
        ? '¿Deseas enviar el cambio sin guía?'
        : '¿Deseas enviar la orden sin guía?'
    }
  },

  methods: {
    async undoDetailAction () {
      if (this.detailActionLoading || !this.detailAction || !this.detailAction.previousAction) return

      this.detailActionLoading = true

      try {
        await this.detailAction.previousAction(...this.detailActionParams)
      } finally {
        setTimeout(() => {
          this.detailActionLoading = false
        }, 500)
      }
    },

    mapDetailOrder (data) {
      return {
        order: data.order,
        quantity: data.quantity,
        cart: data.cart,
        status: data.status,
        name: data.name,
        phones: data.phones || [],
        address: data.address,
        location: data.location,
        department: data.department,
        brand: data.brand,
        createdAt: data.createdAt,
        remitData: data.remitData || [],
        remitDataGenerated: !!data.remitDataGenerated
      }
    },

    mapDetailChange (data) {
      return {
        change: data.change,
        newProducts: data.newProducts,
        order: data.order,
        status: data.status,
        name: data.name,
        phones: data.phones || [],
        address: data.address,
        location: data.location,
        department: data.department,
        brand: data.brand,
        createdAt: data.createdAt,
        remitData: data.remitData || [],
        remitDataGenerated: !!data.remitDataGenerated
      }
    },
    ...mapMutations('pack', [
      'setPackSelected',
      'setPackChangeSelected',
      'setPackAllSelected',
      'setPackAllChangesSelected'
    ]),

    shortName (value) {
      if (!value) return ''
      const names = value.split(' ')
      return names[0] || names[1] || ''
    },

    cutValue (value) {
      if (!value) return ''
      const maxLength = 8
      return value.slice(0, maxLength) + (value.length > maxLength ? '...' : '')
    },

    recordDateLabel (item) {
      return `${this.dateName(item.createdAt)} - ${this.time(item.createdAt)}`
    },

    statusLabel (status) {
      return this.statusSpanish[status] || status
    },

    openPackOrder (order) {
      if (!order || this.headersOnly) return
      this.$router.push({ name: 'OrderPack', params: { code: order } })
    },

    openPackChange (change) {
      if (!change || this.headersOnly) return
      this.$router.push({ name: 'OrderPack', params: { code: formatChangeCode(change) } })
    },

    isOrderSelected (order) {
      return !!this.selectedOrders[order]
    },

    isChangeSelected (change) {
      return !!this.selectedChanges[change]
    },

    setOrderSelected (order, value) {
      this.setPackSelected({ order, value })
    },

    setChangeSelected (change, value) {
      this.setPackChangeSelected({ change, value })
    },

    setAllOrdersSelected (value) {
      this.setPackAllSelected({
        orderIds: this.visibleOrders.map(orderItem => orderItem.order),
        value
      })
    },

    setAllChangesSelected (value) {
      this.setPackAllChangesSelected({
        changeIds: this.visibleChanges.map(changeItem => changeItem.change),
        value
      })
    },

    setAllRecordsSelected (value) {
      this.setAllOrdersSelected(value)
      this.setAllChangesSelected(value)
    },

    cycleRemitSelection () {
      this.cycleOrderRemitSelection()
      this.cycleChangeRemitSelection()
    },

    cycleOrderRemitSelection () {
      if (this.detailType) return
      const selectWithRemit = this.orderRemitSelectWithNext
      const targetOrders = selectWithRemit ? this.ordersWithRemit : this.ordersWithoutRemit

      if (!targetOrders.length) {
        this.orderRemitSelectWithNext = !selectWithRemit
        return
      }

      this.visibleOrders.forEach(orderItem => {
        this.setPackSelected({
          order: orderItem.order,
          value: selectWithRemit ? recordHasRemit(orderItem) : !recordHasRemit(orderItem)
        })
      })

      this.orderRemitSelectWithNext = !selectWithRemit
    },

    cycleChangeRemitSelection () {
      if (this.detailType) return
      const selectWithRemit = this.changeRemitSelectWithNext
      const targetChanges = selectWithRemit ? this.changesWithRemit : this.changesWithoutRemit

      if (!targetChanges.length) {
        this.changeRemitSelectWithNext = !selectWithRemit
        return
      }

      this.visibleChanges.forEach(changeItem => {
        this.setPackChangeSelected({
          change: changeItem.change,
          value: selectWithRemit ? recordHasRemit(changeItem) : !recordHasRemit(changeItem)
        })
      })

      this.changeRemitSelectWithNext = !selectWithRemit
    },

    orderTagStyle (status) {
      const colors = this.colorsStatus[status]
      if (!colors) return {}
      return {
        background: colors.background,
        color: colors.color
      }
    },

    packMessageClass (item) {
      if (item.packMessageType === 'error') return 'is-error'
      if (item.packMessageType === 'ok') return 'is-ok'
      return ''
    },

    getOrderPackBlockMessage (order) {
      if (order && order.status === 'packed') return orderSendBlockMessage(order)
      return orderPackBlockMessageHelper(order)
    },

    printDetailRecord () {
      if (!this.detailData || !recordHasRemit(this.detailData)) return

      if (this.detailType === 'order') {
        const fromList = this.orders.find(item => item.order === this.detailData.order)
        const order = mapPackOrder(fromList ? { ...fromList, ...this.detailData } : this.detailData)

        this.$store.commit('setPrintReturnAddress', {
          orders: [order],
          remitOnly: true
        })
      } else {
        const fromList = this.changes.find(item => item.change === this.detailData.change)
        const change = mapPackChange(fromList ? { ...fromList, ...this.detailData } : this.detailData)

        this.$store.commit('setPrintReturnAddress', {
          changes: [change],
          remitOnly: true
        })
      }

      router.goToPrintReturnAddress()
    },

    async generateDetailRemit () {
      if (!this.detailData || !this.detailType) return

      const variables = this.detailType === 'order'
        ? { order: this.detailData.order }
        : { change: this.detailData.change }

      const errors = []
      const response = await gql.mutate(
        gqlOrder.GENERATE_REMIT_DATA,
        variables,
        false,
        errors
      )

      if (!response || response.error) {
        modals.showMessage({
          message: this.formatRemitError((response && response.error) || errors[0]),
          type: 'error'
        })
        return
      }

      const result = response.data.generateRemitData

      if (!result || !result.success) {
        modals.showMessage({
          message: (result && result.message) || 'Error al generar remite',
          type: 'error'
        })
        return
      }

      modals.showMessage({ message: result.message || 'Remite generado' })
    },

    formatRemitError (error) {
      if (!error) return 'No hubo respuesta del servidor'
      if (typeof error === 'string') return error
      if (error.message) return error.message
      return String(error)
    },

    async packOrder (order) {
      if (!order) return

      const response = await gql.mutate(gqlOrder.PACK, { order })

      if (response) {
        this.$set(this.detailData, 'status', 'packed')
        modals.showMessage({ message: `Se empacó la orden ${order} correctamente` })
      }
    },

    async sendOrder (order) {
      if (!order) return

      const response = await gql.mutate(gqlOrder.SEND, { order, skipGuide: this.skipGuide })

      if (response) {
        this.$set(this.detailData, 'status', 'sent')
        modals.showMessage({ message: `Se envió la orden ${order} correctamente` })
      }
    },

    async unpackOrder (order) {
      if (!order) return

      const response = await gql.mutate(gqlOrder.UNPACK, { order })

      if (response) {
        this.$set(this.detailData, 'status', 'paid')
        modals.showMessage({ message: `Se desempacó la orden ${order} correctamente` })
      }
    },

    async backSendOrder (order) {
      if (!order) return

      const response = await gql.mutate(gqlOrder.BACK_SEND, { order })

      if (response) {
        this.$set(this.detailData, 'status', 'packed')
        modals.showMessage({ message: `Se devolvió el envío de la orden ${order} correctamente` })
      }
    },

    async packChange (change) {
      if (!change) return

      const response = await gql.mutate(gqlChange.PACK, { change, sendNotifications: false })

      if (response) {
        this.$set(this.detailData, 'status', 'packed')
        modals.showMessage({ message: `Se empacó el cambio ${change} correctamente` })
      }
    },

    async sendChange (change) {
      if (!change) return

      const response = await gql.mutate(gqlChange.SEND, { change, sendNotifications: false, skipGuide: this.skipGuide })

      if (response) {
        this.$set(this.detailData, 'status', 'sent')
        modals.showMessage({ message: `Se envió el cambio ${change} correctamente` })
      }
    },

    async unpackChange (change) {
      if (!change) return

      const response = await gql.mutate(gqlChange.UNPACK, { change })

      if (response) {
        this.$set(this.detailData, 'status', 'paid')
        modals.showMessage({ message: `Se desempacó el cambio ${change} correctamente` })
      }
    },

    async backSendChange (change) {
      if (!change) return

      const response = await gql.mutate(gqlChange.BACK_SEND, { change })

      if (response) {
        this.$set(this.detailData, 'status', 'packed')
        modals.showMessage({ message: `Se devolvió el envío del cambio ${change} correctamente` })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/order/pack/PackList.vue